<template>
    <div class="banks-selection-content">
        <div class="bank-title">
            <div class="title">{{ $t('PAYMENT_SELECTION_TITLE') }}</div>
            <div class="actions" style="text-align: center; margin-top: 1rem">
                <ActionButton
                    :label="$t('BUTTON_BACK')"
                    @click="close"
                    color="red"
                ></ActionButton>
            </div>
        </div>
        <div class="gallery-grid">
            <div
                :key="bank.gatewayID"
                @click="selectBank(bank)"
                class="bank"
                v-for="bank in transactionData.gateways"
            >
                <img :src="bank.iconURL" />
                <div class="bank-name">{{ bank.gatewayName }}</div>
            </div>
        </div>
        <transition mode="out-in" name="fade">
            <div class="popup-wrap" v-if="termsVisible">
                <div @click="backToBanks" class="popup-modal"></div>
                <div class="popup-content">
                    <div class="terms-summary">
                        <div>{{ $t('TRANSACTION_SUM_OF_ITEMS') }}:</div>
                        <div>
                            <strong
                                >{{ $Utils.getPriceFromBackend(billsSum) }}
                                {{ $t('PAYMENTS_CURRENCY') }}</strong
                            >
                        </div>
                    </div>
                    <div class="terms-summary -bottom">
                        <div>{{ $t('TRANSACTION_FEE') }}:</div>
                        <div>
                            <strong>2,50 {{ $t('PAYMENTS_CURRENCY') }}</strong>
                        </div>
                    </div>
                    <div class="terms-terms">
                        <div class="terms-text">
                            <div class="regulation">
                                <a
                                    href="https://livekid.com/wp-content/uploads/dokumenty/LiveKid-regulamin-dla-p%C5%82atnika.pdf"
                                    target="_blank"
                                >
                                    ><strong>{{
                                        $t('TRANSACTION_LEGALS_LINK')
                                    }}</strong>
                                </a>
                            </div>
                            <div>{{ $t('TRANSACTION_LEGALS') }}</div>
                        </div>
                        <Switcher
                            :background="true"
                            v-model="acceptTerms"
                        ></Switcher>
                    </div>
                    <div class="terms-submit">
                        <div class="submit-sum">
                            <span class="uppercase">{{ $t('BILL_SUM') }}:</span>
                            {{ sumAfterProvision(billsSum) }}
                            {{ $t('PAYMENTS_CURRENCY') }}
                        </div>
                        <div class="actions">
                            <ActionButton
                                :color="submitColor"
                                :label="$t('TRANSACTION_PAY_NOW')"
                                :loading="loading"
                                @click="finishTransaction"
                            ></ActionButton>
                            <ActionButton
                                :label="$t('BUTTON_BACK')"
                                :loading="loading"
                                @click="backToBanks"
                                color="red"
                            ></ActionButton>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        transactionData: Object,
        vod: Boolean
    },
    data() {
        return {
            termsVisible: false,
            selectedBank: {},
            acceptTerms: false,
            loading: false
        }
    },
    computed: {
        billsSum() {
            let sum = 0
            this.transactionData.bills.forEach(bill => {
                sum += bill.total || bill.amount
            })
            return sum
        },
        submitColor() {
            return this.acceptTerms ? '' : 'grey'
        }
    },
    methods: {
        backToBanks() {
            this.acceptTerms = false
            this.termsVisible = false
        },
        sumAfterProvision(sum) {
            return this.$Utils.getPriceFromBackend(sum + 199)
        },
        close() {
            this.$emit('close')
        },
        selectBank(bank) {
            this.selectedBank = bank
            if (this.vod) {
                this.finishTransaction()
            } else {
                this.termsVisible = true
            }
        },
        finishTransaction() {
            if (this.loading || (!this.acceptTerms && !this.vod)) {
                return
            }
            this.loading = true
            let data = {
                transaction: this.transactionData.transaction,
                payway: this.selectedBank.gatewayID
            }
            this.$api
                .post(this.$Network.provideURL(`v1/payments/url`), data)
                .then(({ data }) => {
                    this.$store.commit(
                        'source/setTransactionItem',
                        this.transactionData.bills[0].uuid
                    )
                    window.location.href = data
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    color: $input;
}
.bank-title {
    font-size: 1.4rem;
    font-family: $input-family;
}
.banks-selection-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 2rem;
    box-sizing: border-box;
    overflow-y: auto;
    z-index: $highest;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
}
.gallery-grid {
    margin-top: 2rem;
    grid-gap: 2rem;
}
.bank {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: $minimal-shadow;
    border-radius: $minimal-radius;
    cursor: pointer;
    transition: $ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.5rem;

    &:hover {
        transform: translateY(0.2rem);
    }
}
.bank img {
    margin-top: auto;
    height: 50%;
}
.bank-name {
    justify-self: flex-end;
    max-width: 100%;
    font-family: $input-family;
    margin-top: auto;
    font-size: 1.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.bank-terms {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.grid-content {
    &.-terms {
        width: 35%;
        min-width: 350px;
        z-index: 250;
    }
}
.terms-title {
    font-size: 22px;
    text-align: center;
    font-family: $input-family;
}
.terms-summary {
    display: flex;
    justify-content: space-between;

    &.-bottom {
        margin-top: 15px;
        padding-bottom: 10px;
        border-bottom: 2px solid rgb(233, 233, 233);
    }
}
.regulation {
    cursor: pointer;
    margin-bottom: 5px;
}
.terms-terms {
    margin-top: 15px;
    display: flex;
    font-size: 14px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgb(233, 233, 233);
}
.terms-submit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    font-size: 30px;
}
.submit-sum {
    font-family: $input-family;
}
.submit-sum span {
    color: $input;
}
</style>
